// extracted by css-extract-rspack-plugin
export default {"label":"toggleSwitchWithLabel_label__BGiqD"};